export function externalAssetPath(path) {
  return "https://dmrpcq96wq0sx.cloudfront.net/trees-online-assets/images/" + path;
}
